export const checkPasswordLength = (password, lng) => {
  if (password.length >= lng) {
    return true
  } else {
    return false
  }
}

export const checkSpecialCharacters = (password) => {
    const pattern = /.*[!@#$%^&-_.*].*/;
    if (pattern.test(password)) {
        return true
    } else {
        return false
    }
}

export const checkUppercase = (password) => {
  const pattern = /[A-Z]/;
  if (pattern.test(password)) {
    return true
  } else {
    return false
  }
}

export const checkLowercase = (password) => {
    const pattern = /[a-z]/;
    if (pattern.test(password)) {
      return true
    } else {
      return false
    }
  }

export const checkNumber = (password) => {
    const pattern = /[0-9]/;
    if (pattern.test(password)) {
        return true
    } else {
        return false
    }
}

export const passwordProgressControl = (validators, number) => {
    try {
        //console.log(validators, number)
        const n = 100 /number
        let correct = 0
        for (const v in validators) {
            if (validators[v]) {
                correct ++
            }
        }
        let result = n*correct
        return result
    } catch (error) {
        //console.log('error progressControl', error)
        return 0
    }
}

export const replaceAll = (string, search, replace) => {
  return string.split(search).join(replace);
}

export const ceduleValidate = (type, document) => {
  try {
      const validateDocumentEcuador = require('validate-document-ecuador');
      const result = validateDocumentEcuador.getValidateDocument( type, document);
      return result
  } catch (error) {
    return { status: 'ERROR', message: error}
  }
}